export const getMainReport = (data: any, isDepartmentManager?: boolean, isDistrictManager?: boolean) => ({
    dataSource: {
        data: data,
        dataSourceType: 'json'
    },
    localization: 'https://cdn.webdatarocks.com/loc/ru.json',
    slice: {
        rows: [
            {
                uniqueName: 'name',
                caption: 'Округ'
            },
            {
                uniqueName: 'department',
                caption: 'Подразделение'
            }
        ],
        columns: [
            {
                uniqueName: 'Measures'
            }
        ],
        measures: [
            {
                "uniqueName": "calc_percent",
                "formula": "if(sum(\"sended\") == 0, 0, sum(\"published\") / sum(\"sended\"))",
                "caption": "% опубликованных",
                "format": "percent_style"
            },
            // {
            //     uniqueName: 'percent',
            //     caption: '% опубликованный историй',
            //     aggregation: 'average',
            //     format: 'percent_style'
            // },
            {
                uniqueName: 'sended',
                caption: 'Направленных',
                aggregation: 'sum'
            },
            {
                uniqueName: 'published',
                caption: 'Опубликованных',
                aggregation: 'sum'
            },
            {
                uniqueName: 'not_published',
                caption: 'Неопубликованных',
                aggregation: 'sum'
            },
            {
                uniqueName: 'under_moderation',
                caption: 'Историй на модерации',
                aggregation: 'sum'
            },
            {
                uniqueName: 'pinned',
                caption: 'Закрепленных',
                aggregation: 'sum'
            },
            {
                uniqueName: 'views',
                caption: 'Просмотров',
                aggregation: 'sum'
            },
            {
                uniqueName: 'likes',
                caption: 'Лайков',
                aggregation: 'sum'
            }
        ],
        expands: {
            expandAll: false
        }
    },
    options: {
        grid: {
            // type: 'classic',
            showHeaders: false,
            showTotals: 'off',
            showGrandTotals: isDepartmentManager ? 'off' : 'on'
        },
        showAggregationLabels: false,
        configuratorButton: false
    },
    formats: [
        {
            name: 'percent_style',
            thousandsSeparator: ' ',
            decimalSeparator: '.',
            maxDecimalPlaces: 2,
            currencySymbol: '',
            currencySymbolAlign: 'left',
            nullValue: '',
            textAlign: 'right',
            isPercent: true
        }
    ]
});
